import WsDropdownSelectController from './ws-dropdown-select.controller';
import WsDropdownSelectTemplate from './ws-dropdown-select.tmpl.html';

const wsDropdownSelectComponent = {
  bindings: {
    items: '<', // Object of type { label: string, selected: boolean }, selected as true shows checkmark
    isDisabled: '<?', // Whether the whole dropdown is disabled, defaults to false
    label: '<?', // The text on the dropdown button
    onItemSelection: '&?',
  },
  controller: WsDropdownSelectController,
  template: WsDropdownSelectTemplate,
};

export default wsDropdownSelectComponent;



// WEBPACK FOOTER //
// ./src/form/ws-dropdown-select/index.js